import { baseUrl } from "./baseUrl";

/**
 * Resolve a partner's `logo` field to something an <img src> can render.
 *
 * The backend stores the partner default logo as a raw S3 object key on the
 * partner record. Some endpoints also expose a presigned URL alongside the
 * key (e.g. `logoUrl`). This helper picks whichever is usable, in order:
 *   1. A presigned URL field provided by the backend (`logoUrl`).
 *   2. The `logo` field itself when it already looks like an http(s) URL.
 *   3. A constructed signed-image proxy URL `<baseUrl>/g/s3-image/<key>`,
 *      following the contract described by the partner-logo backend PR.
 *
 * Returns `null` when no logo is set so callers can branch on truthiness.
 *
 * @param {{ logo?: string | null, logoUrl?: string | null } | null | undefined} partner
 * @returns {string | null}
 */
export function getPartnerLogoPreviewUrl(partner) {
  if (!partner || typeof partner !== "object") return null;

  const logoUrl =
    typeof partner.logoUrl === "string" && partner.logoUrl.length > 0
      ? partner.logoUrl
      : null;
  if (logoUrl) return logoUrl;

  const logo =
    typeof partner.logo === "string" && partner.logo.length > 0
      ? partner.logo
      : null;
  if (!logo) return null;

  if (/^https?:\/\//i.test(logo)) return logo;

  return `${baseUrl}/g/s3-image/${encodeURIComponent(logo)}`;
}
